import React from 'react';

const TmlpLabel = () => {
  return (
    <span className="base-rent-disclaimer-tray">
      Includes variable and usage-based charges, personalized add-ons, and required charges due at
      or prior to move-in or at move-out. See{' '}
      <span>
        <a id="tooltip-anchor" className="underline" href="#fee-table">
          Community Fee Guide
        </a>{' '}
      </span>
      for details.
    </span>
  );
};

export default TmlpLabel;
